import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pen",
  "description": "",
  "published": "2006-11-23T00:00:00.000Z",
  "redirect_from": ["/blog/pen/swizec/350"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`There are some people don't really care about what kind of pen they use, just as long as it writes in the correct colour. And then there are people whom fuss quite some about the kind of pen they use. I am one of the latter, not sure why really, but I find that using the specific type of pen I got accustomed to is simply the best thing for writing by hand. Today the pen died. Nothing major, happens all the time right? It does, but I would never have imagined how hard it can be to get a new pen just like it (but new of course).`}</p>
    <p>{`Went to the store where the pens usually reside and they were fresh out of the thickness I need, then I went to another store and was told they don't at all have such pens and the third store, finally, gave me the pen I needed. Thank you capitalism and desire to sate the customer!`}</p>
    <p>{`Something very lovely also happened today, I got a personal notification of some writing contest directly into my e-mail inbox. It was a surprising event and a very nice one at that. They demand a 1000 word story on a specific topic and by Imhotep they are going to get it.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      